import * as ACTIONS from './actions';
import REDUCERS from './reducers';
import INITIALSTATE from './initialState';

export default {
    ACTIONS,
    REDUCERS,
    INITIALSTATE
}